import {
	FormControl,
	FormHelperText,
	InputAdornment,
	TextField,
	TextFieldProps,
} from '@mui/material';
import {
	FieldPath,
	FieldValues,
	UseControllerProps,
	useController,
} from 'react-hook-form';
import { SketchPicker } from 'react-color';
import SquareIcon from '@mui/icons-material/Square';
import { useRef, useState } from 'react';
import { Popover } from '@mui/material';

export enum InputType {
	normal,
	number,
	amount, // amount of money
	english,
	lastName,
}

export interface AppTextFieldProps {
	inputType?: InputType;
	maxLength?: number;
	showMaxLength?: boolean;
	slotProps?: any;
}

export default function AppColorTextField<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
	maxLength,
	showMaxLength,
	...props
}: AppTextFieldProps &
	UseControllerProps<TFieldValues, TName> &
	TextFieldProps) {
	const { field, fieldState } = useController(props);
	const errorMessage = fieldState.error?.message;
	const anchorRef = useRef(null);
	const [showColorPicker, setShowColorPicker] = useState<any>(false);

	return (
		<>
			<FormControl
				fullWidth={true}
				error={!!errorMessage}
				onMouseEnter={() => setShowColorPicker(true)}
				onMouseLeave={() => setShowColorPicker(false)}
			>
				<TextField
					inputRef={anchorRef}
					variant='filled'
					{...props}
					{...field}
					value={field.value ?? ''}
					onChange={(e) => {
						field.onChange(e.target.value);
					}}
					error={!!errorMessage}
					inputProps={{ maxLength: maxLength, row: 5 }}
					InputProps={{
						startAdornment: field.value && (
							<InputAdornment position='start'>
								<SquareIcon sx={{ color: field.value }} />
							</InputAdornment>
						),
					}}
				/>

				<Popover
					id='colorText'
					open={!!showColorPicker}
					anchorEl={anchorRef.current}
					onClose={() => setShowColorPicker(null)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					anchorReference='anchorEl'
				>
					<SketchPicker
						color={field.value}
						onChange={(color) => field.onChange(color.hex)}
					/>
				</Popover>
				<FormHelperText
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
					}}
				>
					<span>{errorMessage}</span>
					{maxLength && showMaxLength && (
						<span style={{ textAlign: 'right' }}>
							{field.value?.length ?? 0}/{maxLength}
						</span>
					)}
				</FormHelperText>
			</FormControl>
		</>
	);
}
